import React, { useContext } from 'react';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { useLoadingStateContext } from '../../hooks/useLoadingStateContext';
import { useChatUIContext } from '../../hooks/useChatUIContext';
import { useChatMessagesContext } from '../../hooks/useChatMessagesContext';
import sanitizeInput from '../../utils/sanitizeInput';
import { submitChatMessages } from '../../submitChatMessages';
import analytics from '../../analytics/analytics';
import { ExpandableInput } from '../ExpandableInput/ExpandableInput';
import ChatSendIcon from '../../svgs/ChatSendIcon';
import { Box } from 'pcln-design-system';
import VoiceControlButton from '../Realtime/VoiceControlButton/VoiceControlButton';
import { useRealTimeContext } from '../../hooks/useRealTimeContext';
/**
 * Penny Expandable Input
 * @public
 */
const PennyExpandableInput = ({
  submitChatMessagesOptions,
  styles,
  handleExpandableInputHeight
}) => {
  const {
    submitChatMessagesPayload,
    setErrorMessage,
    logFirstMessageSubmitted
  } = useContext(ChatbotDataContext);
  const {
    isLoading
  } = useLoadingStateContext();
  const {
    setOpenErrorComponent
  } = useChatUIContext();
  const {
    chatMessages,
    setChatMessages
  } = useChatMessagesContext();
  const {
    setStartRealTime
  } = useRealTimeContext();
  const VoiceIcon = React.createElement(VoiceControlButton, {
    isExpandableTextArea: true
  });
  const SendIcon = React.createElement(ChatSendIcon, null);
  return React.createElement(Box, {
    style: Object.assign({
      padding: '8px'
    }, styles.inputStyle)
  }, React.createElement(ExpandableInput, {
    placeholder: 'Ask Penny a Question',
    variant: 'glow',
    maxLineHeight: 3,
    voiceIcon: VoiceIcon,
    submitIcon: SendIcon,
    disabled: isLoading,
    onSubmitClickHandler: function (msg) {
      var _a;
      // Set the error message as empty if there is any
      setErrorMessage('');
      // cache the msg on local for reuse
      const chatMessage = {
        role: 'user',
        content: sanitizeInput(msg),
        date: new Date()
      };
      const promptMessage = {
        role: 'user',
        content: sanitizeInput(msg)
      };
      const updatedChatMessages = [...chatMessages, chatMessage];
      setChatMessages([...chatMessages, chatMessage]);
      // Submit the user message
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      (_a = submitChatMessages(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [promptMessage],
          includeSpeech: true
        }),
        setOpenErrorComponent,
        // Local state control
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions))) === null || _a === void 0 ? void 0 : _a.catch(e => analytics.logError({
        message: e === null || e === void 0 ? void 0 : e.message,
        source: 'PennyExpandableInput submitChatMessages'
      }));
      logFirstMessageSubmitted(chatMessages);
    },
    onVoiceClickHandler: function () {
      setStartRealTime(true);
    },
    voiceIconClassName: 'mr-2',
    submitIconClassName: '',
    onHeightChange: handleExpandableInputHeight
  }));
};
export default PennyExpandableInput;